import { FunctionComponent } from 'react'

import config from '@config'
import EmbeddedContent from '@components/EmbeddedContent'

const {
  socialembeds: { tiktokEmbedStaticPageUrl },
} = config

interface TikTokComponentProps {
  url: string
}

const TikTokComponent: FunctionComponent<TikTokComponentProps> = ({ url }) => (
  <EmbeddedContent url={`${tiktokEmbedStaticPageUrl}${url}`} />
)

export default TikTokComponent
